<!-- Viewport-bound app frame (NBO-2331): the document NEVER scrolls. Rail and
     top bar are fixed chrome; the ONE scroll region below the bar owns all
     scrolling. Auth pages render bare; the order/quote/request editors hide
     only the rail and keep the top bar (NBO-2343, split in NBO-2207). -->
<div class="app-frame">
  @if (!railHidden()) {
    <app-shell-rail />
  }
  <div class="app-content-column">
    @if (!topbarHidden()) {
      <app-shell-topbar />
    }
    <div class="app-scroll-region">
      <!-- Environment reminder, not chrome — it scrolls away with content. -->
      <app-production-warning-banner />
      <main class="app-content">
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>
</div>
<!-- Confirmation toasts (ToastService, NBO-2546): bottom left of the content area, over everything. -->
<app-toast-stack />
<div id="recaptcha-container"></div>
